import React, { useState, useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { swapState } from "../../context/swapState";
import "./swap-component.css";

const SwapSetting = ({setIsModalOpen}: any) => {
  const [exmode, setExMode] = useState("OFF");
  const setSwapData = useSetRecoilState(swapState);
  const swapData = useRecoilValue(swapState);
  const [percent, setPercent] = useState(Number(swapData.slippage) * 100);

  useEffect(() => {
    setSwapData({
      ...swapData,
      slippage: (percent / 100).toString(),
    });
  }, [percent]);

  const handleKeydown = (val: any) =>{
    if(val.key === 'Enter'){
      console.log("reached here too");
      setIsModalOpen(false);
    }
  }

  return (
    <div className="setting-modal">
      <div className="setting-heading">Settings</div>
      {/* <div className="slippage">EXPERT MODE</div>
      <div className="input-exmode">
        <div
          onClick={() => setExMode("ON")}
          className={`input-slippage-percent ${
            exmode === "ON" ? "slippage-input__active" : ""
          }`}
        >
          ON
        </div>
        <div
          onClick={() => setExMode("OFF")}
          className={`input-slippage-percent ${
            exmode === "OFF" ? "slippage-input__active" : ""
          }`}
        >
          OFF
        </div>
      </div> */}
      <div className="slippage">SET SLIPPAGE TOLERANCE</div>
      <div className="input-slippage numeric-font">
        <div
          onClick={() => setPercent(0.1)}
          className={`input-slippage-percent ${
            percent === 0.1 ? "slippage-input__active" : ""
          }`}
        >
          0.1%
        </div>
        <div
          onClick={() => setPercent(0.5)}
          className={`input-slippage-percent ${
            percent === 0.5 ? "slippage-input__active" : ""
          }`}
        >
          0.5%
        </div>
        <div
          onClick={() => setPercent(1)}
          className={`input-slippage-percent ${
            percent === 1 ? "slippage-input__active" : ""
          }`}
        >
          1%
        </div>
        <div
          // onClick={() => setPercent(5)}
          className={`input-slippage-manual input-slippage-percent`}
        >
          <input
            type="number"
            className="manual-percent numeric-font"
            value={percent}
            onChange={(val) => setPercent(Number(val.target.value))}
            onKeyDown={handleKeydown}
            placeholder="0.0000"
            min="0" 
            max="100"
          />
          <div className="percent-placeholder">%</div>
        </div>
      </div>
    </div>
  );
};

export default SwapSetting;
